module.exports = __webpack_public_path__ + "static/media/freely.00082db6.ogg";